<div class="filter">
    <label
        class="filter__title"
        [htmlFor]="filter.key"
    >
        {{ filter.title }}
    </label>

    @if (limitedOptions$ | async; as options) {
        @if (options.data; as data) {
            <p-select
                class="filter__input"
                filterBy="label"
                optionLabel="label"
                appendTo="body"
                [inputId]="filter.key"
                [ariaLabel]="filter.title + ', ' + data.length + ' Optionen'"
                [disabled]="!data.length"
                [ngModel]="value$ | async"
                [options]="data"
                [overlayOptions]="overlayOptions"
                [placeholder]="
                    data.length
                        ? (placeholder || 'Bitte wählen')
                        : 'Keine Optionen verfügbar'
                    "
                [dropdownIcon]="data.length ? 'pi pi-chevron-down' : 'pi pi-lock'"
                [showClear]="true"
                [filter]="true"
                [ariaFilterLabel]="'Suchfeld für ' + filter.title"
                [autofocusFilter]="true"
                [emptyFilterMessage]="'Keine Optionen verfügbar'"
                (ngModelChange)="onValueChange([$event])"
                (onClear)="onValueChange(null)"
            />
            @if (areOptionsReduced$ | async) {
                <small
                    class="filter__message"
                >
                    Die Optionen sind durch die Auswahl begrenzt.
                </small>
            }
        } @else {
            @switch (options.error?.key) {
                @case (loadingStatus) {
                    <p-select
                        class="filter__input"
                        [inputId]="filter.key"
                        [ariaLabel]="filter.title + ', wird geladen'"
                        [placeholder]="'Wird geladen...'"
                        [disabled]="true"
                    />
                }
                @default {
                    <div
                        tabindex=0
                        class="filter__error cursor-pointer color-error"
                        role="button"
                        (click)="reloadFilterOptions.emit()"
                        (keydown.enter)="reloadFilterOptions.emit()"
                        (keydown.space)="reloadFilterOptions.emit()"
                    >
                        <i class="pi pi-sync"></i>
                        Die Filterdaten konnten nicht geladen werden. Klicken Sie hier, um es erneut zu versuchen.
                    </div>
                }
            }
        }
    }
</div>
